// extracted by mini-css-extract-plugin
export default {"text":"battle-welcome-modal_text__JGzVI","flexContainer":"battle-welcome-modal_flexContainer__H3eMv"};